import React, { useState, useEffect } from 'react';
import styles from '../ListingScore.module.css';

const CircularScoreMeter = ({ score, maxScore }) => {
    // Calculate the percentage for the arc
    const percentage = (score / maxScore) * 100;
    const [animatedPercentage, setAnimatedPercentage] = useState(0);
    
    // Animate the arc on mount or score change
    useEffect(() => {
        let start;
        const duration = 600; // ms
        const animate = (timestamp) => {
            if (!start) start = timestamp;
            const progress = Math.min((timestamp - start) / duration, 1);
            setAnimatedPercentage(progress * percentage);
            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };
        requestAnimationFrame(animate);
    }, [percentage]);
    
    // Calculate clip path width based on animated percentage
    const svgWidth = 240;
    const svgHeight = 118;
    const clipWidth = (svgWidth * animatedPercentage) / 100;
    
    return (
        <div className={styles.arcScoreMeterContainer}>
            <div className={styles.arcScoreMeterWrapper}>
                {/* Background arc */}
                <svg 
                    width={svgWidth}
                    height={svgHeight}
                    viewBox="0 0 191 94" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                    className={styles.arcBackgroundSvg}
                    preserveAspectRatio="xMidYMid meet"
                >
                    <path d="M7.35852 93.2327C3.13043 93.2327 -0.330592 89.7991 0.0252801 85.5861C0.838185 75.9623 3.18218 66.504 6.98727 57.5541C11.7964 46.2426 18.8453 35.9647 27.7314 27.3072C36.6176 18.6498 47.167 11.7823 58.7773 7.09692C70.3876 2.41153 82.8315 -1.60554e-06 95.3984 0C107.965 1.60554e-06 120.409 2.41154 132.019 7.09692C143.63 11.7823 154.179 18.6498 163.065 27.3072C171.951 35.9647 179 46.2426 183.809 57.5541C187.615 66.504 189.959 75.9623 190.771 85.5861C191.127 89.7992 187.666 93.2328 183.438 93.2328C179.21 93.2328 175.822 89.7967 175.399 85.5899C174.628 77.9268 172.699 70.4022 169.664 63.2627C165.624 53.761 159.703 45.1276 152.239 37.8553C144.774 30.5831 135.913 24.8144 126.16 20.8787C116.407 16.9429 105.955 14.9172 95.3984 14.9172C84.8422 14.9172 74.3893 16.9429 64.6367 20.8787C54.884 24.8144 46.0225 30.5831 38.5582 37.8553C31.0938 45.1276 25.1727 53.761 21.1331 63.2627C18.0977 70.4022 16.1691 77.9268 15.3979 85.5899C14.9744 89.7967 11.5866 93.2327 7.35852 93.2327Z" fill="#FFF7E8"/>
                </svg>
                
                {/* Colored progress arc with clip */}
                <div style={{ 
                    position: 'absolute', 
                    top: 0, 
                    left: 0,
                    width: `${clipWidth}px`,
                    height: `${svgHeight}px`,
                    overflow: 'hidden',
                    transition: 'width 0.6s ease-out'
                }}>
                    <svg 
                        width={svgWidth}
                        height={svgHeight}
                        viewBox="0 0 191 94" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                        className={styles.arcColoredSvg}
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <path d="M7.35852 93.2327C3.13043 93.2327 -0.330615 89.799 0.0252202 85.5859C1.45888 68.6113 7.64478 52.2898 17.9791 38.4319C29.8576 22.5033 46.6071 10.6473 65.8269 4.56313C85.0467 -1.52105 105.75 -1.52104 124.97 4.56314C141.677 9.85204 156.518 19.5025 167.915 32.3982C170.739 35.5926 169.95 40.4616 166.471 42.9247C163.111 45.3029 158.494 44.5387 155.734 41.4845C146.239 30.9763 133.992 23.104 120.239 18.7503C104.094 13.6396 86.703 13.6396 70.5583 18.7503C54.4137 23.861 40.3441 33.82 30.3662 47.2C21.9331 58.5084 16.7887 71.7697 15.3978 85.5898C14.9744 89.7966 11.5866 93.2327 7.35852 93.2327Z" fill="#FFCD71"/>
                    </svg>
                </div>
                
                {/* Score display */}
                <div className={styles.arcScoreDisplay}>
                    <div className={styles.arcScoreNumber}>
                        {score.toFixed(1)}
                        <span className={styles.arcScoreMax}>/10</span>
                    </div>
                    <div className={styles.arcScoreLabel}>Listing Score</div>
                </div>
            </div>
        </div>
    );
};

export default CircularScoreMeter;
